var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIMainCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#3284FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6856 38.2028C39.5452 38.0468 38.9367 37.3603 38.7963 37.2043C38.219 36.5958 38.1878 36.549 37.5325 35.9093C36.7056 35.098 35.4575 34.9264 34.5058 35.5817L33.3668 36.3618C32.9144 36.6738 32.3059 36.6582 31.8846 36.315C30.2776 35.0044 28.8735 33.3974 27.6097 31.2287C26.3615 29.06 25.675 27.0318 25.3318 24.9879C25.2382 24.4419 25.5346 23.9114 26.0339 23.6774L27.2821 23.0845C28.1246 22.6788 28.655 21.7895 28.6082 20.8534C28.577 20.3073 28.2806 19.3556 28.1246 18.8408C27.9217 18.1855 27.8437 17.9514 27.6097 17.265C27.2352 16.204 26.2367 15.5019 25.1134 15.6111C24.1773 15.7048 23.6624 15.7672 22.7887 15.9388C22.1646 16.0636 21.4157 16.2352 20.8852 16.7813C18.0769 19.6833 18.8102 26.9538 22.8511 33.9591C26.8764 40.9332 32.7739 45.2081 36.69 44.272C37.2361 44.1472 37.7198 43.8195 38.0942 43.4139C38.5311 42.9302 38.8119 42.6182 39.2176 42.1033C39.5764 41.6508 40.0601 40.9956 40.2161 40.4183C40.3409 39.9346 40.3253 39.4198 40.1381 38.9517C40.0289 38.6709 39.8572 38.4212 39.6544 38.2028H39.6856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMainCall);
export default __webpack_public_path__ + "static/media/i_main_call.b703418e463af58c723fca5d09928b2f.svg";
export { ForwardRef as ReactComponent };